import { t } from '@avalara/bat-apps-shared/i18n';
import conf from '../conf';
import ExternalLink from './external-link';
import { HelpCenter, HelpCenterBlueTitle, HelpCenterTitle, VideoContainer } from './styled/components/help-center';
import { NoListStyleUl } from './styled/components/sign-up';

const HelpCenterComponent = () => (
  <HelpCenter>
    <HelpCenterTitle>{t('client.general.need-more-guidance')}</HelpCenterTitle>
    <HelpCenterBlueTitle>{t('client.general.avalara-help-center')}</HelpCenterBlueTitle>
    <p>{t('client.general.everything-you-need-to-get-the-most-from-avatax-including-ho')}</p>
    <NoListStyleUl>
      <li>
        <ExternalLink
          href='https://knowledge.avalara.com/bundle/rpb1660904325464_rpb1660904325464/page/Add_an_exempt_customer.html'
          alwaysOpenInNewTab
        >
          {t('client.general.work-with-exempt-customers')}
        </ExternalLink>
      </li>
      <li>
        <ExternalLink
          href='https://knowledge.avalara.com/bundle/rjq1671176624730/page/Avalara_tax_codes.html'
          alwaysOpenInNewTab
        >
          {t('client.general.manage-taxability-of-products-and-services')}
        </ExternalLink>
      </li>
      <li>
        <ExternalLink
          href='https://knowledge.avalara.com/bundle/rjq1671176624730/page/Monthly_tasks_to_maintain_sales_tax_compliance.html'
          alwaysOpenInNewTab
        >
          {t('client.general.review-monthly-tasks-to-maintain-sales-tax-compliance')}
        </ExternalLink>
      </li>
      <li>
        <ExternalLink
          href='https://knowledge.avalara.com/bundle/bpd1665575709431/page/wyd1662958684391.html'
          alwaysOpenInNewTab
        >
          {t('client.general.set-up-returns-for-easy-automated-filing')}
        </ExternalLink>
      </li>
    </NoListStyleUl>
    <VideoContainer>
      <ExternalLink href='https://www.youtube.com/watch?v=gxO8bRuf4Rw' alwaysOpenInNewTab>
        <img
          src={`${conf.ASSET_PATH}/assets/images/sign-up/img_SetupSeries@2x.png`}
          alt={t('client.accessibility.avatax-setup-series')}
        />
        <HelpCenterTitle>{t('client.general.the-avatax-setup-series')}</HelpCenterTitle>
        {t('client.general.step-by-step-videos')}
      </ExternalLink>
    </VideoContainer>
  </HelpCenter>
);

export default HelpCenterComponent;
